import React from 'react';
import { Label, Icon, Popup } from 'semantic-ui-react';
import GreaterOfBadge from './GreaterOfBadge';


const ContractTypeLabel = ({
    row,
    contract,
    hansFinancialNote,
    providerQualifiesForTier,
    isProdMove,
    getContractDetails,
    tedFilter
}) => {
    const handleClick = (goxNonBillableCare = '') => {
        getContractDetails(
            row.ABBR,
            row.doctorId,
            row.contractType,
            row.dentistWorkTimeType,
            row.doctorPayVariables.userId,
            goxNonBillableCare,
            isProdMove
        );
    };

    const CONTRACT_CONFIG = {
        'Prod Hurdle': {
            className: 'primaryColor additionals',
            content: 'Prod Hurdle'
        },
        'Collections': {
            className: 'bg-color-collections color-white additionals',
            content: `Collections ${providerQualifiesForTier ?? ''}`
        },
        'Greater Of': {
            className: 'bg-color-primary color-white additionals',
            content: `Greater Of${row.contract ?? ''} ${providerQualifiesForTier}`,
            useGreaterOfBadge: true
        },
        'GOZ': {
            style: { color: 'black', backgroundColor: '#FF00FF' },
            className: 'additionals',
            content: `GOZ ${providerQualifiesForTier ?? ''}`,
            passGoxNonBillableCare: true,
            useGreaterOfBadge: true
        },
        'GOX': {
            style: { color: 'white', backgroundColor: '#008820ff' },
            className: 'additionals',
            content: `GOX ${providerQualifiesForTier ?? ''}`,
            passGoxNonBillableCare: true,
            useGreaterOfBadge: true
        },
        'Sum Of': {
            className: 'primaryColor additionals',
            content: `Sum Of${(tedFilter && row.doctorPayVariables?.tedCollections) ? ' (TED)' : ''} ${providerQualifiesForTier ?? ''}`
        },
        'UKG HYN': {
            className: 'additionals',
            content: `${row.contractType?.trim()} ${providerQualifiesForTier ?? ''}`
        },
        'TMPHYN': {
            className: 'bg-color-collections color-white additionals',
            content: `TMPHYN ${providerQualifiesForTier ?? ''}`
        },
        'Greater Of w/HYN': {
            style: { backgroundColor: '#07036B', color: '#ffffff' },
            className: 'additionals',
            content: `GO/HYN ${providerQualifiesForTier ?? ''}`,
            useGreaterOfBadge: true
        },
        'Sum Of w/HYN': {
            className: 'primaryColor additionals',
            content: `SO/HYN ${providerQualifiesForTier ?? ''}`
        },
        'Collections w/HYN': {
            className: 'bg-color-collections additionals',
            content: `CO/HYN ${providerQualifiesForTier ?? ''}`
        },
        'TMPDOC': {
            className: 'bg-color-collections color-white additionals',
            content: `TMPDOC ${providerQualifiesForTier ?? ''}`
        },
        'GOX w/HYN': {
            style: { color: 'black', backgroundColor: '#5FE47F' },
            className: 'additionals',
            content: `GOX/HYN ${providerQualifiesForTier ?? ''}`,
            passGoxNonBillableCare: true,
            useGreaterOfBadge: true
        },
        'Collections Offset': {
            className: 'bg-color-collections additionals',
            content: `CO/Offset ${providerQualifiesForTier ?? ''}`
        },
        'GO GA': {
            style: { color: 'white', backgroundColor: '#E65100' },
            className: 'additionals',
            content: `GO GA ${providerQualifiesForTier ?? ''}`
        },
        'GO GA w/HYN': {
            style: { color: 'white', backgroundColor: '#E65100' },
            className: 'additionals',
            content: `GO GA/HYN ${providerQualifiesForTier ?? ''}`
        }
    };

    const config = CONTRACT_CONFIG[row.contractType];

    const renderLabel = () => {
        if (!config) return null;

        const label = (
            <Label
                onClick={() => handleClick(config.passGoxNonBillableCare ? row.GoxNonBillableCare : '')}
                className={'cursorPointer ' + config.className}
                style={config.style}
                tag={isProdMove}
                icon={contract ? 'file alternate' : undefined}
                content={config.content}
            />
        );

        if (config.useGreaterOfBadge) {
            return (
                <div className="greater-of-category-badge" style={{ display: 'inline-block', position: 'relative' }}>
                    {label}
                    <GreaterOfBadge category={row.greater_of_category} />
                </div>
            );
        }

        return label;
    };

    const isReviewed = row.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorCustomContracts?.[0]?.reviewed;

    return (
        <td className="d-flex">
            <Icon
                name={'dollar sign'}
                color={hansFinancialNote ? 'red' : 'green'}
                className={'mr10'}
            />

            {renderLabel()}

            {row.customContract && (
                <Popup
                    trigger={
                        <span className='ml15 mt05'>
                            <Icon
                                name='cut'
                                className='rotate90'
                                color={isReviewed ? 'green' : 'red'}
                            />
                        </span>
                    }
                    content={row.doctorPayVariables?.someValues?.Doctors?.[0]?.customContractDetails || 'No details available'}
                    position='top center'
                />
            )}
        </td>
    );
};

export default ContractTypeLabel;
